import { api } from '../../../services/api'

export async function unlinkGoogleCalendar(auth0_id: string): Promise<boolean> {
  const response = await api.delete(
    `/api/me/identities/${auth0_id}/google_calendar`
  )
  return response.status >= 200 && response.status < 300
}
